import telehealth_icon from '../../../assets/telemedicine.png'
import patient_at_home_icon from '../../../assets/home-health.png';
import hospital_icon from '../../../assets/traditionalSite.png';
import mobile_health_icon from '../../../assets/esource.png';
import pharmacy_icon from '../../../assets/local-clinic.png';
import local_lab_icon from '../../../assets/local-Lab.png';
import ip_direct_icon from '../../../assets/ipDirectShipment.png'
import e_consent_icon from '../../../assets/econsent.png';
import {
  arrayMove,
} from "@dnd-kit/sortable";

export const modality_options_dict:Digital_Protocol_SoA_Table_Data.ModalityOptionsDict ={
    
    "eSource & Wearables": {
      "icon": mobile_health_icon,
      "color": '#FFB600'
    },
    "Telemedicine": {
      "icon": telehealth_icon,
      "color": '#3DD5B0'
    },
    "Home Health": {
      "icon": patient_at_home_icon,
      "color": '#295477'
    },
    "Local Lab & Sample Collection": {
      "icon": local_lab_icon,
      "color": '#657DFF'
    },
    "Local Clinic": {
      "icon": pharmacy_icon,
      "color": '#E72B33'
    },
    "IP Direct Shipment": {
      "icon": ip_direct_icon,
      "color": '#00C6F7'
    },
    "eConsent": {
      "icon": e_consent_icon,
      "color": '#299D8F'
    },
    "Traditional Site": {
      "icon": hospital_icon,
      "color":'#D93954'
    },
    "": {
        "icon":'',
        "color":'white'
    },
}
export const mapConditions = (activities, visitTobeMapped) => {  
    return activities.map(item => ({  
      ...item,  
      condition: [...visitTobeMapped.condition]  
    }));  
  };  
    
export const updateActivities = (items, newArr, setFunction, dispatchFunction, dispatchType, dispatch, modalityOptions) => {  
    const updatedItems = items.map(activityItem => {  
        const newItem = newArr.find(newItem => newItem['Standard Activity'] === activityItem['Standard Activity']);  
        if (newItem) {  
        return {  
            ...activityItem,   
             condition: newItem?.condition.map((c) => {  
              const modalityIndex = modalityOptions.findIndex(k => k.name === c.modality_name);  
              const isModalityValid = modalityIndex > -1 && activityItem?.modality[modalityIndex] > 0;  
              return {  
                ...c,  
                modality_name: isModalityValid ? c.modality_name : '',  
                modality: isModalityValid ? c.modality : '',  
              };  
            }),
            Frequency: newItem.Frequency,  
            visit_frequency: newItem.visit_frequency  
        };  
        }  
        return activityItem;  
    });  

    newArr = newArr.filter(newItem => !updatedItems.some(activityItem => activityItem['Standard Activity'] === newItem['Standard Activity']));  
        
    setFunction(updatedItems);  

    dispatch(  
        dispatchFunction({  
        [dispatchType]: updatedItems  
        })  
    );  

    return newArr;  
};  
  
export const updateAllCategories = (condition, Categories, evt, tmpCon, data, setData, dispatch, updateAction) => {  
    const totalVisitTmp = condition.filter(c => c.modality && c.modality !== "")?.length;  
    
    const tmpData = data.slice(0);  
    const targetItem = tmpData.find(  
      (ele) => ele["Standard Activity"] == evt["Standard Activity"]  
    );  
    
    if (targetItem) {  
      targetItem.condition = tmpCon;  
      targetItem.totalVisit = totalVisitTmp;  
      setData(tmpData);  
      dispatch(updateAction({  
        [Categories]: tmpData  
      }));  
    }  
}; 

export const addPeriodIDtoCondition = (category, periodType, convertedWeeks, convertedDays) => {      
  const _array = periodType.flatMap(obj => Array(obj.no_of_visits).fill(obj.period_id));        
  category.forEach(cat => {  
      const tempCondition = JSON.parse(JSON.stringify(cat.condition));  
      tempCondition.forEach((c, idx) => {  
          c.period_id = _array[idx];  
          c.visits = idx + 1;   
          c.weeks = convertedWeeks[idx];  
          c.days = convertedDays[idx];  
      });  
      cat.condition = tempCondition;  
  });      
  return category;  
};  

export const reOrderVisitsInPeriodType = (p_visits, p_period_data) => {
  if(!p_period_data) return
  let _newVisits = JSON.parse(JSON.stringify(p_visits)).map((c,i) => c = i + 1)
  let _periodType = JSON.parse(JSON.stringify(p_period_data))
  _periodType?.forEach((period, index) => {
    const visits = _newVisits?.splice(0, period.no_of_visits)
    period.visits = visits

  })
  return _periodType
}

export const addConditionByPeriod = (category, item, operateArr, whetherDuplicate, direction) => {    
  const calculateIndex = (arr, limit) => arr.slice(0, limit).reduce((sum, itm) => sum + itm.no_of_visits, 0);    
  category.forEach(cat => {    
    let tempCondition = cat?.condition || [];
  
    const startIndex = calculateIndex(operateArr, item.period_order_index - 1);    
    const targetIndex = calculateIndex(operateArr, item.period_order_index);    
    const movePartLength = item.no_of_visits;    
    let elements = tempCondition.slice(startIndex, startIndex + movePartLength)?.map( elem => ({...elem, visits: '', period_id:''}));  
    
    if (!whetherDuplicate) {    
      elements = elements.map(el => ({ ...el, visits:'', period_id: '', modality: '', modality_name: '', modality_frequency: null }));    
    }    
    
    const insertIndex = (direction === "right") ? targetIndex : startIndex;    
    tempCondition.splice(insertIndex, 0, ...elements);    
    tempCondition = tempCondition.map((c, i) => ({ ...c, visits: i + 1 }));  
    tempCondition = tempCondition.map((k, i) => ({...k, period_id: operateArr.find(z => z.visits.includes(k.visits))?.period_id  }))
    cat.condition = tempCondition
    cat.totalVisit = tempCondition.filter(c => c.modality && c.modality !== "").length;    
  });    

  return category;    
}; 

export const incrementVisit = (period_array) => {  
  let updated = [...period_array];  
    
  let visitCount = 0;  
  updated.forEach((period) => {  
    period.visits = Array.from({ length: period.no_of_visits }, () => ++visitCount);  
  });  
    
  return updated;  
};

export const deleteConditionByPeriod = (category, item, operateArr) => {
  const calculateIndex = (arr, limit) => arr.slice(0, limit).reduce((sum, itm) => sum + itm.no_of_visits, 0);  
  category.forEach (cat => {
    const tempCondition = cat?.condition
    let startIndex = 0;  
    let targetIndex = 0; 
    let insertIndex = 0;
    startIndex = calculateIndex(operateArr, item.period_order_index - 1);  
    targetIndex = calculateIndex(operateArr, item.period_order_index);  
    insertIndex = targetIndex-item.no_of_visits; 
    tempCondition?.splice(insertIndex,item.no_of_visits) 
    tempCondition?.map((c,i) => c.visits = i + 1)
    cat.condition = tempCondition
    cat.totalVisit = tempCondition?.filter(c => c.modality && c.modality!=="")?.length
  })
  return category
}

export const resetConditionByPeriod = (category, item) => {
  const periodId = item?.period_id
  category.forEach (cat => {
    const tempCondition = cat?.condition
    const updatedCondition = tempCondition?.map(cat => {  
      if (cat.period_id === periodId) {  
          return {  
              ...cat,  
              modality: "",  
              modality_name: ""  
          };  
      }  
      return cat;  
    });  
    cat.condition = updatedCondition
    cat.totalVisit = updatedCondition.filter(c => c.modality && c.modality!=="")?.length
  })
  return category
}

export const resetConditionVisit = (category, visit_id) => {
  const visitId = visit_id
  category.forEach (cat => {
    const tempCondition = cat?.condition
    const updatedCondition = tempCondition?.map(cat => {  
      if (cat.visits === visitId) {  
          return {  
              ...cat,  
              modality: "",  
              modality_name: ""  
          };  
      }  
      return cat;  
    });  
    cat.condition = updatedCondition
    cat.totalVisit = updatedCondition.filter(c => c.modality && c.modality!=="")?.length
  })
  return category
}


export const renewCondition = (category, newVisits, newWeeks, newDays, newPeriod) => {
  category.forEach((cat) => {
    let tempCondition = cat?.condition;
    tempCondition = tempCondition?.map((c, i) => ({  
      ...c,  
      visits: newVisits?.[i],  
      weeks: newWeeks?.[i],  
      days: newDays?.[i],
      period_id: newPeriod?.[i] || c.period_id,
    })); 
    cat.condition = tempCondition;
    cat.totalVisit = tempCondition?.filter(
      (c) => c.modality && c.modality !== ""
    ).length;
  });
  return category;
};

export const duplicateConditionByPeriod = (entity, periodsMapped, periodTobeMapped) => {
  entity.forEach((cat) => {
    const tempCondition = cat?.condition
    const indices = tempCondition?.reduce((acc, itm, idx) => {  
      if (itm.period_id === periodTobeMapped.period_id) {  
        acc.push(idx);  
      }  
      return acc;  
    }, []); 

    periodsMapped.forEach(item => {  
      tempCondition?.map( (con, zIdx) => {
        if(periodsMapped.map(k => k.period_id).includes(con.period_id)) { 
          let elem = tempCondition?.slice(indices[0], indices[indices?.length - 1] + 1);  

          elem = elem.map((k) => ({...k, period_id: con.period_id, visits: zIdx+1}))
          let length = tempCondition?.filter(itm => itm.period_id == con.period_id)?.length
          let insertIndex = tempCondition?.findIndex(itm => itm.period_id == con.period_id)
          tempCondition?.splice(insertIndex, length, ...elem) 
        }
      }) 
   })
   cat.condition = tempCondition
   return {...cat, condition: tempCondition}
  })
  return entity;
}

export const handleDragData = (activeIndex, overIndex, targetArr, operateArr, periodData) => {

  const calculateIndex = (arr, end) => arr.slice(0, end).reduce((acc, item) => acc + item['no_of_visits'], 0);  

  const startIndex = calculateIndex(operateArr, activeIndex);  
  const targetIndex = calculateIndex(operateArr, overIndex + (activeIndex < overIndex ? 1 : 0));  
    
  const movePartLength = periodData[activeIndex].no_of_visits;  
  const elements = targetArr?.splice(startIndex, movePartLength);  

  const insertIndex = activeIndex < overIndex ? targetIndex - elements?.length : targetIndex;  

  targetArr?.splice(insertIndex, 0, ...elements);  
  return targetArr;  
}

export const reorderCondition = (category, activeIndex, overIndex, prevState, periodData) => {
  category.forEach (cat => {
    const tempCondition = cat?.condition
    handleDragData(activeIndex, overIndex, tempCondition, prevState, periodData)
    cat.condition = tempCondition
  })
  return category
}

export const reorderConditionByVisit = (category, activeIndex, overIndex) => {
  category.forEach (cat => {
    const tempCondition = JSON.parse(JSON.stringify(cat.condition))
    cat.condition = arrayMove(tempCondition, activeIndex, overIndex)
  })
  return category
}

export const deleteConditionByVisit = (category, idx) => {
  category.forEach((cat) => {
    const tempCondition = [...cat.condition];
    tempCondition?.splice(idx, 1);
    tempCondition.forEach((c, index) => { c.visits = index + 1 });
    cat.condition = tempCondition;
    cat.totalVisit = tempCondition?.filter(
      (c) => c.modality && c.modality !== ""
    ).length;
  });
  return category;
};

export const getModalityOptions = (modalityOpts) => {
  let finalModalityOptions = [];
  if (modalityOpts != null && modalityOpts != undefined) {
    modalityOpts.forEach((modality) => {
      if (modality.name in modality_options_dict) {
        finalModalityOptions.push({
          key: modality.key,
          name: modality.name,
          icon: modality_options_dict[modality.name].icon,
          color: modality_options_dict[modality.name].color,
        });
      } else {
        finalModalityOptions.push({
          key: modality.key,
          name: modality.name,
          icon: "",
          color: "white",
        });
      }
    });
    finalModalityOptions.push({
      key: "",
      name: "",
      icon: "",
      color: "white",
    });
    return finalModalityOptions;
  } else {
    return [];
  }
};

export function removeDuplicates(evtItem, addedItem, libraryData) {
  const libraryCategory = JSON.parse(JSON.stringify(libraryData));
  return [...evtItem, ...addedItem].reduce((unique, item) => {
    const found = unique.find(
      (obj) => obj["Standard Activity"] === item["Standard Activity"]
    );
    const update_cost = libraryCategory.find(
      (obj) => obj["Standard Activity"] === item["Standard Activity"]
    )?.cost;
    if (!found) {
      unique.push({
        ...item,
        cost: update_cost ?? item?.cost,
      });
    }
    return unique;
  }, []);
}

export const filterDeletedItems = (eventsConfigureItems, addedItem) => {
  if (addedItem?.length == 0) {
    return eventsConfigureItems.map((item, idx) => ({
      ...item,
      activity_order_index: idx + 1,
    }));
  } else {
    return addedItem?.filter(
      (item) => !eventsConfigureItems?.includes(item["Standard Activity"])
    );
  }
};

export const insertConditionByVisit = (category, idx, whetherCopy: true) => {
  category.forEach((cat) => {
    const tempCondition = JSON.parse(JSON.stringify(cat.condition));

    const modalityNew = whetherCopy ? cat.condition[idx].modality : "";
    const modalityNameNew = whetherCopy
      ? cat.condition[idx].modality_name
      : "";

    const modalityFrequencyNew = whetherCopy
      ? cat.condition[idx].modality_frequency
      : null;

    tempCondition.splice(idx + 1, 0, {
      visits: null,
      modality: modalityNew,
      modality_name: modalityNameNew,
      period_id: cat.condition[idx].period_id,
      weeks:null,
      days:null,
      modality_frequency: modalityFrequencyNew,
    });

    cat.condition = tempCondition.map( (con, idx) => ({...con, visits: idx+1}));
    cat.totalVisit = tempCondition.filter(
      (c) => c.modality && c.modality !== ""
    ).length;
  });
  return category;
};

export const getWeeksOrderIndex = (_newWeeks) => {
  let lastNonNullIndex = -1; 
  for (let i = 0; i < _newWeeks.length; i++) {  
    if (_newWeeks[i] !== null) {  
      if (lastNonNullIndex !== -1 && _newWeeks[lastNonNullIndex] > _newWeeks[i]) {  
        return i;  
      }  
      lastNonNullIndex = i;  
    }  
  }   
  return -1;  
}


export const weekDayWindowMapping = (data, visitUnit) => 
  data.map(item => item[`${visitUnit.toLowerCase()}_visit_window`]).flat();


export const  getVisitWindowValues = (visitUnit, idx, weekVisitWindow, dayVisitWindow) => { 
  const visitWindow = visitUnit === 'Week' ? weekVisitWindow : dayVisitWindow;  
  const lowerValue = visitWindow?.[idx]?.lower_visit_value ?? '';  
  const upperValue = visitWindow?.[idx]?.upper_visit_value ?? '';  
  const type = visitWindow?.[idx]?.visit_window_type_id ?? '';

  if (type === 1 && typeof upperValue === "number") {    
    return `-/+ ${upperValue}`;  
  } else if (type === 2 && typeof lowerValue === "number" && typeof upperValue === "number") {    
    return `${lowerValue}, +${upperValue}`;  
  } else if (type === 3 && typeof lowerValue === "number") {    
    return `${lowerValue}`;  
  } else if (type === 4 && typeof upperValue === "number") {    
    return `+${upperValue}`;  
  } else {    
    return '';  
  }  
} 

export const addItem = (arr, index, copy, idx) => {  
  const item = copy ? arr[idx] : null;  
  const newArr = [...arr];  
  newArr.splice(index, 0, item);  
  return newArr;  
}; 

export const addWindowItem = (arr, index, copy, idx) => {  
  const initWindowVal = {  
    lower_visit_value: null,  
    upper_visit_value: null,  
    visit_window_type_id: null,  
  };  

  const item = copy ? arr[idx] : initWindowVal;  
  const newArr = [...arr];  
  newArr.splice(index, 0, item);  
  return newArr;  
};  

export const convertVisitWindow = (visit_window_val, conversionFactor) => {  
  const { lower_visit_value, upper_visit_value, visit_window_type_id } = visit_window_val;  
  
  return {  
    lower_visit_value: lower_visit_value ? Math.round(lower_visit_value * conversionFactor) : null,  
    upper_visit_value: upper_visit_value ? Math.round(upper_visit_value * conversionFactor) : null,  
    visit_window_type_id,  
  };  
}  
  
export const checkOrder = (arr) => {  
  let outOfOrder = [];  
  let lastNonNullIndex = -1;  
  for (let i = 0; i < arr.length; i++) {  
      if (arr[i] !== null) {  
          if (lastNonNullIndex !== -1 && arr[i] < arr[lastNonNullIndex]) {  
              // Current index is out of order compared to the last non-null index  
              outOfOrder.push(i);  
          }  
          lastNonNullIndex = i;  
      }  
  }  
  return outOfOrder;  
};  
  
export const findOutOfOrderIndices = (array) => {  
    const outOfOrderIndices = []; // Array to store indices of out-of-order elements  
  
    let lastNumber = null; // Initialize to track the last valid number  
    let lastIndex = -1; // Track the index of the last valid number  
  
    for (let i = 0; i < array.length; i++) {  
        if (array[i] === null) {  
            continue; // Skip null values  
        }  
  
        // Compare with the last valid number  
        if (lastNumber !== null && array[i] < lastNumber) {  
            outOfOrderIndices.push(i); // Add index of the current out-of-order element to the array  
        }  
  
        // Find the next valid number to compare  
        let nextNumber = null;  
        for (let j = i + 1; j < array.length; j++) {  
            if (array[j] !== null) {  
                nextNumber = array[j];  
                break; // Stop at the next non-null number  
            }  
        }  
  
        // Compare with the next valid number  
        if (nextNumber !== null && array[i] > nextNumber) {  
            outOfOrderIndices.push(i); // Add index again if it's out of order with the next number  
        }  
  
        // Update lastNumber and lastIndex to the current value and index  
        lastNumber = array[i];  
        lastIndex = i;  
    }  
  
    return outOfOrderIndices; // Return array of out-of-order indices  
};  

